var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-1,.cls-2{fill:none;}.cls-3{fill:#f4ce83;}.cls-4{fill:#f6ecdc;}.cls-5{fill:#f8d8a2;}.cls-6{fill:#f8e5be;}.cls-7{fill:#eee;}.cls-8{fill:#e8a760;}.cls-9{fill:#e8f2f9;}.cls-10{fill:#ebc8bb;}.cls-11{fill:#ececec;}.cls-12{fill:#ffd07e;}.cls-13{fill:#e5f2f8;}.cls-14{fill:#e5f6f9;}.cls-15{fill:#fbcd7a;}.cls-16{fill:#825d3f;}.cls-17{fill:#015a66;}.cls-18{fill:#a0d0e7;}.cls-19{fill:#a17787;}.cls-20{fill:#8c8c8c;}.cls-21{fill:#86393e;}.cls-22{fill:#a98f66;}.cls-23{fill:#bbdcef;}.cls-24{fill:#af7e49;}.cls-25{fill:#a57750;}.cls-26{fill:#b2b2b2;}.cls-27{fill:#bcab93;}.cls-28{fill:#dcc1b1;}.cls-29{fill:#db9d6a;}.cls-30{fill:#e0bf90;}.cls-31{fill:#d8c5a7;}.cls-32{fill:#af8e6f;}.cls-33{fill:#41939e;}.cls-34{fill:#8a6339;}.cls-35{fill:#5d3336;}.cls-36{fill:#767f81;}.cls-37{fill:#828c8e;}.cls-38{fill:#835e3f;}.cls-2{stroke:#03454c;stroke-linecap:round;stroke-miterlimit:10;stroke-width:.29px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Peinture"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Peinture-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Parquet"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "97.24 71.65 48.92 100 0 71.65 48.64 43.91 97.24 71.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "100 28.37 97.21 30.14 88.28 24.83 88.91 24.25 60.12 7.53 59.2 7.89 51.67 3.68 6.11 30.14 2.76 28.42 51.67 0 100 28.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "51.67 94.1 51.67 98.05 50.54 97.39 18.83 79.01 2.76 69.7 2.76 28.42 6.11 30.14 6.11 66.02 5.98 66.26 6.11 66.34 6.11 67.4 18.83 74.85 50.54 93.43 51.67 94.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "100 28.37 100 69.7 51.67 98.05 51.67 94.1 97.21 67.5 97.21 66.34 97.21 66.2 97.21 66.02 97.21 30.14 100 28.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "87.57 46.64 87.57 48.2 75.37 41.33 75.37 17.87 76.84 18.71 76.84 40.71 87.57 46.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "73.77 38.75 73.77 40.31 61.58 33.44 61.58 9.97 63.05 10.85 63.05 32.81 73.77 38.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "97.21 30.14 97.21 65.23 51.68 38.13 51.67 38.13 51.67 3.68 59.2 7.89 59.2 34.51 88.28 50.91 88.28 24.83 97.21 30.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "88.28 50.16 88.28 50.91 59.2 34.51 59.2 7.89 60.12 7.53 60.12 34.23 88.28 50.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m60.12,7.53v26.69l28.15,15.93v-25.33l.64-.57L60.12,7.53Zm13.65,32.77l-12.2-6.87V9.97l12.16,7.25.03,23.09Zm13.79,7.89l-12.2-6.87v-23.46l1.47.84,10.73,6.12v23.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "97.22 65.23 97.22 67.5 51.69 94.1 50.55 93.43 18.84 74.85 6.13 67.4 6.13 64.53 51.69 38.13 97.22 65.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "51.67 3.68 51.67 38.13 6.11 64.53 6.11 30.14 51.67 3.68"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "97.13 64.7 52.14 91.16 6.66 64.59 51.46 38.25 74.86 51.8 80.22 54.91 80.87 55.29 81.94 55.91 90.58 60.91 91.74 61.58 97.13 64.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "97.13 64.7 97.13 65.86 52.14 92.32 52.14 91.16 97.13 64.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "52.14 91.16 52.14 92.32 6.66 65.75 6.66 64.59 52.14 91.16"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "56.05 40.69 56.05 41.39 51.67 38.83 51.67 38.13 56.05 40.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "56.05 40.69 56.05 41.39 44.79 48.01 44.79 47.31 56.05 40.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "56.16 40.69 56.16 41.39 45.4 47.71 45.4 47.02 56.16 40.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "60.49 43.29 60.49 43.98 56.11 41.42 56.11 40.73 60.49 43.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "51.67 38.13 51.67 38.83 40.41 45.45 40.41 44.76 51.67 38.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "40.37 44.78 40.37 45.48 40.34 45.46 40.35 44.77 40.37 44.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "64.96 45.84 64.96 46.53 64.91 46.56 64.91 45.87 64.96 45.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "56.11 40.73 56.11 41.42 45.4 47.72 45.4 47.03 56.11 40.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "49.78 49.58 49.78 50.28 45.4 47.72 45.4 47.03 49.78 49.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "60.49 43.29 60.49 43.98 49.78 50.28 49.78 49.58 60.49 43.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "44.79 47.31 44.79 48.01 40.41 45.45 40.41 44.76 44.79 47.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "40.41 44.76 40.41 45.45 19.62 57.68 19.62 56.98 40.41 44.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "44.75 47.34 44.75 48.03 40.37 45.48 40.37 44.78 44.75 47.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "44.77 47.35 44.77 48.05 44.75 48.03 44.75 47.34 44.77 47.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "44.81 47.33 44.81 48.02 44.77 48.05 44.77 47.35 44.81 47.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "44.75 47.34 44.75 48.03 24 60.23 24 59.54 44.75 47.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "45.4 47.02 45.4 47.71 27.5 58.24 27.5 57.54 45.4 47.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "49.73 49.61 49.73 50.31 45.35 47.75 45.35 47.06 49.73 49.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "49.81 49.6 49.8 50.29 49.75 50.32 49.75 49.63 49.81 49.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "49.75 49.63 49.75 50.32 49.73 50.31 49.73 49.61 49.75 49.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "49.73 49.61 49.73 50.31 31.89 60.8 31.89 60.11 49.73 49.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "60.6 43.29 60.6 43.98 44.19 53.63 44.19 52.94 60.6 43.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "64.91 45.87 64.91 46.56 60.54 44.01 60.55 43.32 64.91 45.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "24 59.54 24 60.23 19.62 57.68 19.62 56.98 24 59.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "19.57 57.01 19.57 57.71 19.55 57.69 19.55 57 19.57 57.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "19.62 56.98 19.62 57.68 7.46 64.82 7.47 64.13 19.62 56.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "23.95 59.57 23.95 60.26 19.57 57.71 19.57 57.01 23.95 59.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "23.97 59.58 23.97 60.28 23.95 60.26 23.95 59.57 23.97 59.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "24.02 59.55 24.02 60.25 23.97 60.28 23.97 59.58 24.02 59.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "45.34 47.05 45.34 47.74 27.51 58.24 27.51 57.55 45.34 47.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "31.89 60.11 31.89 60.8 27.51 58.24 27.51 57.55 31.89 60.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "31.84 60.13 31.84 60.83 27.46 58.27 27.46 57.57 31.84 60.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "31.91 60.12 31.91 60.81 31.86 60.84 31.87 60.15 31.91 60.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "23.95 59.57 23.95 60.26 11.84 67.38 11.85 66.69 23.95 59.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "27.5 57.54 27.5 58.24 11.85 67.44 11.85 66.75 27.5 57.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "31.84 60.13 31.84 60.83 16.29 69.97 16.29 69.28 31.84 60.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "31.91 60.12 31.87 60.15 31.84 60.13 27.46 57.57 27.5 57.54 31.89 60.11 31.91 60.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "31.87 60.15 31.86 60.84 31.84 60.83 31.84 60.13 31.87 60.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "27.46 57.57 27.46 58.26 11.91 67.41 11.91 66.72 27.46 57.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "16.29 69.28 16.29 69.97 11.91 67.41 11.91 66.72 16.29 69.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "56.16 40.69 60.6 43.29 44.19 52.94 16.34 69.31 11.85 66.75 27.46 57.57 11.91 66.72 16.29 69.28 31.84 60.13 49.73 49.61 60.49 43.29 56.11 40.73 45.4 47.03 56.16 40.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "60.6 43.29 64.96 45.84 64.91 45.87 60.55 43.32 60.6 43.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "51.67 38.13 56.05 40.69 44.79 47.31 40.41 44.76 51.67 38.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "19.62 56.98 40.37 44.78 44.75 47.34 24 59.54 19.62 56.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "11.85 66.69 11.84 67.38 7.46 64.82 7.47 64.13 11.85 66.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m51.68,38.08l4.48,2.62-10.76,6.33-17.9,10.52-15.65,9.2-4.48-2.62,44.31-26.05Zm-6.93,9.26l11.31-6.65-4.38-2.56-11.26,6.62-20.79,12.23-12.16,7.15,4.38,2.56,12.1-7.12,20.8-12.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "44.81 47.33 44.77 47.35 44.75 47.34 40.37 44.78 40.35 44.77 40.39 44.74 40.41 44.76 44.79 47.31 44.81 47.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "69.33 48.46 69.33 49.15 64.97 46.6 64.97 45.91 69.33 48.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "56.11 40.73 60.49 43.29 49.78 49.58 45.4 47.03 56.11 40.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "49.81 49.6 49.75 49.63 49.73 49.61 45.35 47.06 45.4 47.02 49.78 49.58 49.81 49.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "69.33 48.46 69.33 49.15 25.15 75.14 25.15 74.44 69.33 48.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "69.47 48.46 69.47 49.15 57.9 55.95 57.9 55.26 69.47 48.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "48.55 55.49 48.55 56.18 44.19 53.63 44.19 52.94 48.55 55.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "64.91 45.87 64.91 46.56 48.55 56.18 48.55 55.49 64.91 45.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "60.55 43.32 64.91 45.87 48.55 55.49 44.19 52.94 60.55 43.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "44.19 52.94 44.19 53.63 16.34 70 16.34 69.31 44.19 52.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "48.5 55.52 48.5 56.21 44.13 53.66 44.13 52.97 48.5 55.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "48.55 55.49 48.5 55.52 44.13 52.97 44.19 52.94 48.55 55.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "48.55 55.49 48.55 56.18 48.5 56.21 48.5 55.52 48.55 55.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "24.02 59.55 23.97 59.58 23.95 59.57 19.57 57.01 19.55 57 19.6 56.97 19.62 56.98 24 59.54 24.02 59.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "27.51 57.55 45.35 47.06 49.73 49.61 31.89 60.11 27.51 57.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "7.47 64.13 19.57 57.01 23.95 59.57 11.85 66.69 7.47 64.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "11.85 66.75 11.85 67.44 7.37 64.82 7.38 64.13 11.85 66.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "11.91 66.72 27.46 57.57 31.84 60.13 16.29 69.28 11.91 66.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "16.34 69.31 16.34 70 11.85 67.44 11.85 66.75 16.34 69.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "16.34 69.31 44.13 52.97 48.5 55.52 20.71 71.86 16.34 69.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "20.71 71.86 20.71 72.55 16.34 70 16.34 69.31 20.71 71.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "48.5 55.52 48.5 56.21 20.71 72.55 20.71 71.86 48.5 55.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "20.66 71.89 20.65 72.58 16.29 70.03 16.29 69.34 20.66 71.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "20.71 71.86 20.71 72.55 20.65 72.58 20.66 71.89 20.71 71.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "16.29 69.34 16.34 69.31 20.71 71.86 20.66 71.89 16.29 69.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "64.97 45.91 64.97 46.6 20.78 72.59 20.78 71.89 64.97 45.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "25.15 74.44 25.15 75.14 20.78 72.59 20.78 71.89 25.15 74.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "69.33 48.46 25.15 74.44 20.78 71.89 64.97 45.91 69.33 48.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "25.21 74.49 25.21 75.18 20.65 72.59 20.65 71.89 25.21 74.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m64.91,45.87l4.56,2.59-11.57,6.8-32.69,19.22-4.56-2.59,27.85-16.38,16.41-9.65Zm-39.76,28.58l44.19-25.98-4.36-2.55-44.19,25.98,4.36,2.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "57.9 55.26 57.9 55.95 25.21 75.18 25.21 74.49 57.9 55.26"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "69.47 48.46 73.82 51.01 73.77 51.04 69.41 48.5 69.47 48.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "73.82 51.01 73.82 51.7 73.76 51.73 73.77 51.04 73.82 51.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "73.77 51.04 73.76 51.73 69.41 49.19 69.41 48.5 73.77 51.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "78.32 53.63 78.32 54.33 78.22 54.27 78.22 53.57 78.32 53.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "78.19 53.63 78.19 54.33 73.83 51.78 73.83 51.09 78.19 53.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "82.64 56.11 82.63 56.8 82.49 56.88 82.49 56.19 82.64 56.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "78.19 53.63 78.19 54.33 34 80.31 34 79.62 78.19 53.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "78.32 53.63 78.32 54.33 33.99 80.39 34 79.7 78.32 53.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "82.49 56.19 82.49 56.88 78.26 54.41 78.26 53.72 82.49 56.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "73.77 51.04 73.76 51.73 62.26 58.5 62.26 57.81 73.77 51.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "62.26 57.81 62.26 58.5 57.9 55.95 57.9 55.26 62.26 57.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "69.41 48.5 73.77 51.04 62.26 57.81 57.9 55.26 69.41 48.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "62.26 57.81 62.26 58.5 62.2 58.53 62.21 57.84 62.26 57.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "62.21 57.84 62.2 58.53 57.85 55.99 57.85 55.29 62.21 57.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "29.56 77.03 29.56 77.72 25.21 75.18 25.21 74.49 29.56 77.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "62.21 57.84 62.2 58.53 29.56 77.72 29.56 77.03 62.21 57.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "29.56 77.03 29.56 77.72 29.5 77.76 29.5 77.07 29.56 77.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "25.15 74.52 25.21 74.49 29.56 77.03 29.5 77.07 25.15 74.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "73.83 51.09 73.83 51.78 29.65 77.76 29.65 77.07 73.83 51.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "78.19 53.63 34 79.62 29.65 77.07 73.83 51.09 78.19 53.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "34 79.62 34 80.31 29.65 77.76 29.65 77.07 34 79.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m78.22,53.57l.11.06-44.33,26.07-.11-.06-4.39-2.57,32.71-19.23,11.56-6.8,4.45,2.53Zm-44.22,26.04l44.19-25.98-4.36-2.55-44.19,25.98,4.36,2.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "62.26 57.81 62.21 57.84 57.85 55.29 57.9 55.26 62.26 57.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "86.93 58.78 86.92 59.47 82.63 56.97 82.64 56.28 86.93 58.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "25.21 74.49 57.85 55.29 62.21 57.84 29.56 77.03 25.21 74.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "29.5 77.07 29.5 77.76 25.15 75.21 25.15 74.52 29.5 77.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "33.89 79.64 33.89 80.33 29.5 77.76 29.5 77.07 33.89 79.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "78.26 53.72 78.26 54.41 34.14 80.35 34.15 79.66 78.26 53.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "34 79.7 33.99 80.39 33.89 80.33 33.89 79.64 34 79.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "38.38 82.13 38.38 82.82 34.14 80.35 34.15 79.66 38.38 82.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "82.49 56.19 82.49 56.88 38.38 82.82 38.38 82.13 82.49 56.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "82.49 56.19 38.38 82.13 34.15 79.66 78.26 53.72 82.49 56.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "82.64 56.28 82.63 56.97 38.52 82.91 38.53 82.21 82.64 56.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "38.38 82.13 38.38 82.82 38.24 82.91 38.24 82.21 38.38 82.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "38.44 82.33 38.43 83.02 38.24 82.91 38.24 82.21 38.44 82.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "38.44 82.33 38.43 83.02 33.86 80.35 33.86 79.66 38.44 82.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "82.64 56.11 82.49 56.19 78.26 53.72 34.15 79.66 38.38 82.13 38.24 82.21 38.44 82.33 33.86 79.66 34 79.7 78.32 53.63 78.22 53.57 82.64 56.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "86.93 58.78 86.92 59.47 42.81 85.41 42.81 84.72 86.93 58.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "42.81 84.72 42.81 85.41 38.52 82.91 38.53 82.21 42.81 84.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m82.64,56.11l4.5,2.63-44.39,26.11-4.3-2.51-.2-.11.14-.08,44.11-25.94.14-.08Zm-39.82,28.61l44.11-25.94-4.29-2.51-44.11,25.94,4.29,2.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "86.93 58.78 42.81 84.72 38.53 82.21 82.64 56.28 86.93 58.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "87.13 58.74 87.13 59.43 42.74 85.54 42.74 84.84 87.13 58.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "42.74 84.84 42.74 85.54 38.43 83.02 38.44 82.33 42.74 84.84"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "91.42 61.41 91.42 62.1 87.13 59.6 87.14 58.9 91.42 61.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "91.57 61.33 91.56 62.02 91.42 62.1 91.42 61.41 91.57 61.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "95.85 63.99 95.85 64.69 91.57 62.19 91.57 61.49 95.85 63.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "87.14 58.9 87.13 59.6 43.02 85.54 43.02 84.84 87.14 58.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "91.42 61.41 91.42 62.1 47.31 88.04 47.31 87.35 91.42 61.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "47.31 87.35 47.31 88.04 43.02 85.54 43.02 84.84 47.31 87.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "47.31 87.35 47.31 88.04 47.17 88.12 47.17 87.43 47.31 87.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "91.42 61.41 47.31 87.35 43.02 84.84 87.14 58.9 91.42 61.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "91.57 61.49 91.57 62.19 47.45 88.12 47.46 87.43 91.57 61.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "47.17 87.43 47.17 88.12 42.81 85.58 42.82 84.89 47.17 87.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "43.02 84.84 47.31 87.35 47.17 87.43 42.82 84.89 87.13 58.74 91.57 61.33 91.42 61.41 87.14 58.9 43.02 84.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "47.31 87.51 47.31 88.21 47.17 88.12 47.17 87.43 47.31 87.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "51.74 89.93 51.74 90.63 47.45 88.12 47.46 87.43 51.74 89.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "95.85 63.99 51.74 89.93 47.46 87.43 91.57 61.49 95.85 63.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "95.85 63.99 95.85 64.69 51.74 90.63 51.74 89.93 95.85 63.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m91.57,61.33l4.57,2.67-44.39,26.11-4.42-2.58-.14-.08,44.39-26.11Zm-39.83,28.61l44.11-25.94-4.28-2.5-44.11,25.94,4.28,2.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "96.13 63.99 96.13 64.69 51.74 90.79 51.74 90.1 96.13 63.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "51.74 90.1 51.74 90.79 47.31 88.21 47.31 87.51 51.74 90.1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "tapis"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "72.54 57.97 37.05 78.84 11.52 63.93 47.02 43.06 72.54 57.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "72.54 57.97 72.54 58.25 37.04 79.12 37.05 78.84 72.54 57.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "37.05 78.84 37.04 79.12 11.52 64.21 11.52 63.93 37.05 78.84"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "pot_de_peinture"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m41.49,52.87c0,.71-.4,1.37-1.08,1.89.32-.3.5-.64.5-.99,0-1.19-1.98-2.15-4.42-2.15s-4.42.96-4.42,2.15c0,.43.27.84.72,1.17-.83-.54-1.34-1.27-1.34-2.07,0-1.68,2.25-3.05,5.02-3.05s5.02,1.36,5.02,3.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m40.9,53.77c0,.36-.18.69-.5.99-.76.58-1.86.99-3.11,1.12-.08.01-.17.01-.25.02-.1,0-.2.01-.3.01-.09,0-.17,0-.26,0h-.02c-.11,0-.21,0-.32,0-.15,0-.3-.01-.44-.03-.04,0-.07,0-.11-.01-1.1-.12-2.08-.45-2.81-.93-.45-.33-.72-.74-.72-1.17,0-1.19,1.98-2.15,4.42-2.15s4.42.96,4.42,2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m41.49,52.87v6.09c0,1.68-2.25,3.05-5.02,3.05s-5.02-1.37-5.02-3.05v-6.09c0,.8.51,1.53,1.34,2.07.63.47,1.64.82,2.81.93.04,0,.07,0,.11.01.14.01.29.02.44.03.11,0,.21,0,.32,0h.02c.09,0,.17,0,.26,0,.1,0,.2,0,.3-.01.09,0,.17-.01.25-.02,1.36-.12,2.49-.54,3.11-1.12.68-.52,1.08-1.18,1.08-1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m31.44,55.34c-.45.71-.95,1.94,0,3.05.12.14.27.29.44.43,2.22,1.76,4.49-2,4.49-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bassine"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "31.54 64.3 31.54 65.01 27.78 67.17 27.78 66.39 31.54 64.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "31.92 63.37 25.59 59.61 21.51 61.99 27.84 65.73 31.92 63.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "25.58 59.95 22.15 61.99 27.84 65.41 31.37 63.37 25.58 59.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "25.59 59.95 25.59 60.67 27.84 61.99 28.36 63.37 29.85 64.25 31.37 63.37 25.59 59.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "27.84 61.99 24.91 63.65 22.72 62.34 25.59 60.67 27.84 61.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "25.59 60.67 23.93 61.63 27.84 61.99 25.59 60.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "27.84 66.42 31.92 64.08 31.92 63.37 27.84 65.73 27.84 66.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "21.51 61.99 27.84 65.73 27.84 66.42 21.51 62.75 21.51 61.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m25.98,64.3s.04-.19.17-.09.17.19.28.17.04-.33.04-.33l-.14-.54s-.02-.24.16,0l.37.38s.19.19.21,0,0-.42,0-.42c0,0,.05-.21.23-.07,0,0,.18.35.34.28s.08-.3.08-.3l-.18-.63s-.04-.31.13-.14.34.64.34.64c0,0,.21.27.34.23s.14-.2.14-.2v-.4s-.18-.32-.07-.37.35.24.35.24l.47.64s.19.36.31.18.15-.18.15-.18c0,0,0,.47.07.56s.17.26.17.26l-2.1,1.25-1.88-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m31.32,65.32l-2.19-2.06c-.1-.1-.27-.1-.38,0-.1.1-.1.27,0,.38l2.19,2.06c.1.1.27.1.38,0s.1-.27,0-.38Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-35",
    cx: 31.16,
    cy: 65.55,
    r: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 31.24,
    cy: 65.61,
    r: 0.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "21.92 62.98 27.78 66.39 27.78 67.17 21.92 63.73 21.92 62.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m34.66,65.96c-.11-.24-.34-.38-.5-.3l-3.26,1.98c-.16.08-.2.34-.09.58s.34.38.5.3l3.26-1.98c.16-.08.2-.34.09-.58Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 31.11,
    cy: 68.08,
    rx: 0.33,
    ry: 0.48,
    transform: "translate(-25.5 19.11) rotate(-24.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m31.39,65.49l.7.73s.1.16-.05.28-1.82,1.06-1.82,1.06c0,0-.12.09,0,.26s.28.43.28.43l.36-.24s.14-.08.21,0,.03.18.03.18l-.58.41s-.2.08-.36-.24-.35-.62-.35-.62c0,0-.11-.27.23-.45s1.63-.94,1.63-.94l-.6-.64.32-.22Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "peinture",
    className: "cls-33",
    points: "15.87 59.21 15.87 36.81 13.69 38.13 13.69 42.47 11.68 43.61 11.68 45.22 9.49 46.24 9.49 44.74 6.13 46.84 6.13 65.07 15.87 59.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "peinture-2",
    className: "cls-33",
    points: "25.62 53.28 25.62 30.29 23.43 31.6 23.43 28.31 21.43 29.45 21.43 31.06 19.24 32.08 19.24 30.59 15.87 32.68 15.87 59.14 25.62 53.28"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaint);
export default __webpack_public_path__ + "static/media/paint.c174e7a3b15bc6ceff2506a00b4ed845.svg";
export { ForwardRef as ReactComponent };